<script setup>
import { ref } from 'vue'
import { useUserStore } from '../stores/userStore'

const userStore = useUserStore()
const isSidebarCollapsed = ref(false)

const menuItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'fa-home',
    path: '/client'
  },
  {
    id: 'games',
    label: 'My Games',
    icon: 'fa-basketball-ball',
    path: '/client/games'
  },
  {
    id: 'api',
    label: 'API Access',
    icon: 'fa-code',
    path: '/client/api'
  },
  {
    id: 'billing',
    label: 'Billing',
    icon: 'fa-credit-card',
    path: '/client/billing'
  }
]
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex">
    <!-- Simplified Sidebar -->
    <aside 
      class="fixed left-0 top-0 h-full bg-white shadow-lg transition-all duration-300"
      :class="isSidebarCollapsed ? 'w-16' : 'w-64'"
    >
      <!-- Logo -->
      <div class="flex items-center p-4 border-b border-gray-200">
        <img src="/OC_print_logo_icon_color.svg" alt="OddsComposer Logo" class="h-8 w-auto">
      </div>

      <!-- Menu Items -->
      <nav class="p-4">
        <ul class="space-y-2">
          <li v-for="item in menuItems" :key="item.id">
            <router-link 
              :to="item.path"
              class="flex items-center p-2 rounded-lg transition-colors"
              :class="$route.path.startsWith(item.path) ? 'bg-pink-50 text-pink-500' : 'text-gray-700 hover:bg-gray-100'"
            >
              <i :class="`fas ${item.icon} text-lg`"></i>
              <span v-if="!isSidebarCollapsed" class="ml-3">{{ item.label }}</span>
            </router-link>
          </li>
        </ul>
      </nav>

      <!-- User Profile -->
      <div class="absolute bottom-0 left-0 right-0 border-t border-gray-200 p-4">
        <button
          @click="userStore.logout"
          class="w-full flex items-center p-2 text-red-600 hover:bg-red-50 rounded-lg"
        >
          <i class="fas fa-sign-out-alt"></i>
          <span v-if="!isSidebarCollapsed" class="ml-3">Logout</span>
        </button>
      </div>
    </aside>

    <!-- Main Content -->
    <main 
      class="flex-1 transition-all duration-300"
      :class="isSidebarCollapsed ? 'ml-16' : 'ml-64'"
    >
      <router-view></router-view>
    </main>
  </div>
</template> 